// SVG icon components for the shared account experience (presentation only).

export const ChevR = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--color-gray-500)"
    strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden style={{ flexShrink: 0 }}>
    <path d="M9 18l6-6-6-6" />
  </svg>
)
// Gray disclosure chevron for expandable rows (points down; rotates to up when
// the row is open). Matches ChevR's weight/color — the "dropdown icon" the
// history receipts get so $0 and paid rows read identically.
export const ChevDown = ({ open = false }: { open?: boolean }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-gray-500)"
    strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden
    style={{ flexShrink: 0, transition: 'transform 0.15s ease', transform: open ? 'rotate(180deg)' : 'none' }}>
    <path d="M6 9l6 6 6-6" />
  </svg>
)
// Dedicated left-facing chevron for BackButton — brand-purple and smaller
// (14x14) than ChevR, and already drawn pointing left so no scaleX flip is
// needed. Do NOT reuse ChevR here: ChevR is hardcoded gray for disclosure
// rows, and recoloring/resizing it would regress the ~15 other row usages.
export const ChevBackL = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand)"
    strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden style={{ flexShrink: 0 }}>
    <path d="M15 18l-6-6 6-6" />
  </svg>
)
export const CarSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand)"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M5 17H3v-5l2-5h14l2 5v5h-2" /><circle cx="7.5" cy="17.5" r="1.5" /><circle cx="16.5" cy="17.5" r="1.5" /><path d="M5 12h14" />
  </svg>
)
export const CardSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand)"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" />
  </svg>
)
export const ChatSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand)"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
)
export const PhoneSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand)"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
)
export const HelpSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand)"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
)
export const ShieldSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand)"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" /><path d="m9 12 2 2 4-4" />
  </svg>
)
export const DocSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand)"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" />
  </svg>
)
export const MapPinSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand)"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
)
export const BellSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand)"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
)
// Red stroke (not brand purple) to match the danger row it sits in — every
// other row icon here is brand-purple, but Sign out is the one destructive/
// exit action in the list.
export const LogoutSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-error)"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" />
  </svg>
)

// The Parkify widget mark (the real app/favicon glyph — not a hand-drawn shape),
// white on transparent so it composites on the brand-purple avatar circle exactly
// like white initials do. Used as the generic avatar when a parker hasn't saved a
// name yet. Sized by height so the mark keeps its aspect ratio.
export const WidgetMark = ({ size = 26 }: { size?: number }) => (
  <img
    src="data:image/png;base64,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"
    alt=""
    aria-hidden
    draggable={false}
    style={{ display: 'block', height: size, width: 'auto' }}
  />
)
